<script setup lang="ts">
const props = defineProps<{
  collapsed: boolean | undefined
  repName: string
}>()
</script>

<template>
  <!-- Avatar + name + "Advisor" + chevron. Sizing is responsive: a touch
       bigger on mobile (the sidebar is a wider slide-over there) and tighter
       on the desktop rail (lg:). `min-w-0` + `truncate` keep a long advisor
       name from overflowing the narrow rail. The old box used `h-5 py-6 -my-3`
       (a 20px height shorter than the 32px avatar) — replaced with a clean
       items-center row. -->
  <a class="block select-none hover:cursor-pointer" @click="navigateTo('/profile/advisor')">
    <div
      class="flex items-center w-full min-w-0 py-1.5 rounded hover:bg-white/60 transition-colors duration-300"
      :class="collapsed ? 'justify-center' : 'px-2'"
    >
      <UAvatar
        :src="useAdvisorProfilePic(repName)"
        :alt="repName"
        class="shrink-0 size-10"
      />
      <div v-if="!collapsed" class="flex items-center justify-between gap-2 w-full min-w-0 ml-3">
        <div class="min-w-0">
          <h3 class="text-sm lg:text-xs font-medium text-black truncate">{{ repName }}</h3>
          <p class="font-extralight text-xs lg:text-[0.6rem] text-[#5A5A42]">Advisor</p>
        </div>
        <UIcon name="i-lucide-chevron-right" class="size-5 lg:size-4 shrink-0 text-gray-500" />
      </div>
    </div>
  </a>
</template>

<style scoped>

</style>
